import { useCallback, useEffect, useState } from 'react';
import type { PanelAction, PanelPresentationProps } from './panel-actions';

/** Presentation state is independent of the business panel's fields and component. */
export function usePanelPresentation(fullPage: boolean, pathname: string, sessionId?: string) {
  const [panels, setPanels] = useState<
    Record<
      string,
      {
        action: PanelAction;
        presentation: PanelPresentationProps['presentation'];
        path: string;
      }
    >
  >({});
  const opened = sessionId ? panels[sessionId] : undefined;
  const closePanel = useCallback((id?: string) => {
    setPanels((current) => {
      if (!id) return {};
      const next = { ...current };
      delete next[id];
      return next;
    });
  }, []);
  const openPanel = useCallback((action: PanelAction, full: boolean, path: string, id: string) => {
    setPanels((current) => ({
      ...current,
      [id]: { action, presentation: full ? 'sidebar' : 'business', path },
    }));
  }, []);
  useEffect(() => {
    if (
      opened &&
      ((opened.presentation === 'sidebar' && !fullPage) ||
        (opened.presentation === 'business' && (fullPage || pathname !== opened.path)))
    )
      closePanel(sessionId);
  }, [opened, fullPage, pathname, sessionId, closePanel]);
  return {
    activePanel: opened?.action,
    panelPlacement: opened?.presentation,
    businessPanelOpen: Boolean(
      opened?.presentation === 'business' && !fullPage && pathname === opened.path,
    ),
    openPanel,
    closePanel,
  };
}
